import { render, staticRenderFns } from "./AddProjectClient.vue?vue&type=template&id=b3722bf8&scoped=true&"
import script from "./AddProjectClient.vue?vue&type=script&lang=js&"
export * from "./AddProjectClient.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectClient.vue?vue&type=style&index=0&id=b3722bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3722bf8",
  null
  
)

export default component.exports